import { z } from 'zod';
export const metalTypeSchema = z.enum(['Gold', 'Silver', 'Platinum', 'Palladium', 'Other']);
export const createProductSchema = z.object({
    product_code: z.string().min(1, 'Product code is required'),
    description: z.string().min(1, 'Description is required'),
    metal_type: metalTypeSchema,
    weight_oz: z.number().positive().nullable().optional(),
});
export const updateProductSchema = createProductSchema.partial().extend({
    is_active: z.boolean().optional(),
});
//# sourceMappingURL=product.js.map